/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is the 3-minute test the standard?`)
};

const es_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué el test de 3 minutos es el estándar?`)
};

const de_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist der 3-Minuten-Test der Standard?`)
};

const nl_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is de test van 3 minuten de standaard?`)
};

const fr_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi le test de 3 minutes est-il la norme ?`)
};

const it_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il test da 3 minuti è lo standard?`)
};

const pt_br2_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o teste de 3 minutos é o padrão?`)
};

const pt_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o teste de 3 minutos é o padrão?`)
};

const ja_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ3分間のテストが標準なのですか？`)
};

const zh_typing_u3_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么3分钟测试是标准？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u3_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u3_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u3_faq3_q", locale)
	if (locale === "en") return en_typing_u3_faq3_q(inputs)
	if (locale === "es") return es_typing_u3_faq3_q(inputs)
	if (locale === "de") return de_typing_u3_faq3_q(inputs)
	if (locale === "nl") return nl_typing_u3_faq3_q(inputs)
	if (locale === "fr") return fr_typing_u3_faq3_q(inputs)
	if (locale === "it") return it_typing_u3_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u3_faq3_q(inputs)
	if (locale === "pt") return pt_typing_u3_faq3_q(inputs)
	if (locale === "ja") return ja_typing_u3_faq3_q(inputs)
	return zh_typing_u3_faq3_q(inputs)
};